import React, { useState, useCallback, useMemo } from "react";
import { Box, Collapse, IconButton, ListItem, Radio, RadioGroup, FormControlLabel, Typography } from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import BorderOuterIcon from "@material-ui/icons/BorderOuter";
import CloseIcon from "@material-ui/icons/Close";
import { IPackageShort, GamesType, SelectionMode } from "../../../../interfaces";
import { useTranslation } from "react-i18next";
import { useStyles } from "../styles";
import { GameList } from "./game-list";

interface PackageRowProps {
    packageItem: IPackageShort;
    selection: GamesType;
    onUpdate: (updatedSelection: GamesType) => void;
    onRemove: (packageId: number) => void;
}

export const PackageRow: React.FC<PackageRowProps> = React.memo(({ packageItem, selection, onUpdate, onRemove }) => {
    const [t] = useTranslation();
    const classes = useStyles();
    const [isOpen, setIsOpen] = useState(false);

    const toggleOpen = useCallback(() => setIsOpen(prev => !prev), []);

    const handleModeChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
        onUpdate({
            ...selection,
            games: e.target.value === "ALL_PROVIDER" ? [] : selection.games,
            mode: e.target.value as SelectionMode
        });
    }, [selection, onUpdate]);

    const toggleGame = useCallback((gameId: number) => {
        const { games } = selection;
        const newGames = games.includes(gameId)
            ? games.filter(id => id !== gameId)
            : [...games, gameId];

        onUpdate({ ...selection, games: newGames });
    }, [selection, onUpdate]);

    const isCustomMode = useMemo(() => selection.mode === "CUSTOM", [selection.mode]);

    return (
        <React.Fragment>
            <ListItem button onClick={toggleOpen} className={classes.packet}>
                <Box display="flex" alignItems="center" flexGrow={1}>
                    <BorderOuterIcon className={classes.icon} />
                    <Typography style={{ marginLeft: 8 }}>{packageItem.name}</Typography>
                    {isOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                </Box>
                <IconButton
                    onClick={(e) => {
                        e.stopPropagation();
                        onRemove(packageItem.id);
                    }}
                    style={{ padding: 0 }}
                >
                    <CloseIcon />
                </IconButton>
            </ListItem>

            <Collapse in={isOpen}>
                <Box p={2}>
                    <RadioGroup value={selection.mode || "ALL_PROVIDER"} onChange={handleModeChange}>
                        <FormControlLabel value="ALL_PROVIDER" control={<Radio />} label={t("Все игры провайдера")} />
                        <FormControlLabel value="CUSTOM" control={<Radio />} label={t("Выбрать вручную")} />
                    </RadioGroup>

                    <Collapse in={isCustomMode} unmountOnExit>
                        <GameList
                            packageId={packageItem.id}
                            selectedGames={selection.games}
                            isPackageOpen={isOpen}
                            isCustomMode={isCustomMode}
                            onToggleGame={toggleGame}
                        />
                    </Collapse>
                </Box>
            </Collapse>
        </React.Fragment>
    );
});